<template>
  <div class="research_group_container">
    <div class="hd research-background-color">
      <span class="icon icon-left navshare" @click="goBack" v-if="!isResearchGroup && !isWapp "></span>
      <span class="header_title">课题组管理</span>
    </div>
    <div class="box_2" v-if="hasLogin && displayChosenResearchGroup && displayChosenResearchGroup.researchGroupName">
      <div class="layerWrap">
        <object class="blue-layer" :data="'/static/img/svg/首页蓝色背景.svg'" type="image/svg+xml"/>
        <img
            class="avator"
            src="/static/img/avator.png"
        />
        <div class="container">
          <span class="luWei">{{customerName}}</span>
          <div class="outer">
            <div class="tagWrap" v-if="displayChosenResearchGroup.leaderNo === customerNo"><span class="tag">课题组组长</span></div>
            <div class="tagWrap" v-else><span class="tag">课题组成员</span></div>
            <div class="tagWrap" v-if="displayChosenResearchGroup.approverNo === customerNo"><span class="tag">审批人</span></div>
            <div class="tagWrap" v-if="displayChosenResearchGroup.accountCustomerNo === customerNo"><span class="tag">对账人</span></div>
          </div>
          <div class="outer2">
            <div class="tagWrap_none" v-if="displayChosenResearchGroup.approveType === approveTypeNone"><span class="tag">{{researchGroupApproveTypeDictionary[displayChosenResearchGroup.approveType]}}</span></div>
            <div v-else-if="displayChosenResearchGroup.approveType === approveTypeThreshold">
              <div class="tagWrap_threshold" v-if="displayChosenResearchGroup.approveThreshold"><span class="tag">单笔订单限额￥{{displayChosenResearchGroup.approveThreshold}}</span>
              </div>
              <div class="tagWrap_threshold" v-if="displayChosenResearchGroup.monthlyLimit" ><span class="tag">单月累积限额￥{{displayChosenResearchGroup.monthlyLimit}}</span>
              </div>
            </div>

            <div class="tagWrap_threshold" v-else><span class="tag">{{researchGroupApproveTypeDictionary[displayChosenResearchGroup.approveType]}}</span></div>
          </div>
        </div>
      </div>
      <!--      <div class="benefit_detail" @click="$router.push({name: 'Benefit'})">-->
      <!--        <object class="actionBg" :data="'/static/img/svg/home-benefit-background.svg'" type="image/svg+xml"/>-->
      <!--        <span class="text_G">G客权益</span>-->
      <!--        <div class="wrap_g">-->
      <!--          <span class="info_g">工具类产品</span> <span class="num_g">{{parseFloat((displayChosenResearchGroup.discountA * 10).toFixed(10))}}</span>-->
      <!--          <span class="text_g">折</span>-->
      <!--          <span class="info_g">服务类产品</span> <span class="num_g">{{parseFloat((displayChosenResearchGroup.discountB * 10).toFixed(10))}}</span>-->
      <!--          <span class="text_g">折</span>-->
      <!--        </div>-->
      <!--        <div class="block_g">-->
      <!--          <span class="info_benefit">查看更多权益</span>-->
      <!--          <svg class="double_arrow" width="200px" height="200.00px" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M543.3 474.3L187.4 113.9c-19-20.2-50.70000001-21.2-71-2.3-0.8 0.7-1.5 1.5-2.29999999 2.3-10.4 9.50000001-16.1 23-15.70000001 37.1-0.4 14.1 5.3 27.6 15.7 37.1l319.1 323.3-319.1 323.29999999c-10.4 9.50000001-16.1 23.1-15.7 37.10000001-0.4 14.1 5.3 27.6 15.7 37.1 19 20.2 50.70000001 21.2 71 2.3 0.8-0.7 1.5-1.5 2.3-2.3L543.3 548.5c20.5-19.9 21-52.60000001 1.1-73.1-0.3-0.4-0.7-0.8-1.1-1.1z m366.3 0L553.79999999 113.9c-19-20.2-50.70000001-21.2-70.99999999-2.3-0.8 0.7-1.5 1.5-2.3 2.3-10.4 9.50000001-16.1 23-15.7 37.1-0.4 14.1 5.3 27.6 15.6 37.1l319.2 323.3-319.2 323.29999999c-10.4 9.50000001-16.1 23.1-15.6 37.10000001-0.4 14 5.3 27.6 15.6 37.1 19 20.2 50.70000001 21.2 71 2.3 0.8-0.7 1.5-1.5 2.3-2.3L909.6 548.5c20.5-19.9 21-52.60000001 1.1-73.1l-1.1-1.1z" fill="#E6C3A0" /></svg>-->
      <!--        </div>-->
      <!--        <span class="vip">VIP {{displayChosenResearchGroup.vipLevel}}</span>-->
      <!--      </div>-->
      <div class="group_detail">
        <div class="block">
          <div class="group">
            <span class="info_2">{{displayChosenResearchGroup.researchGroupName}}</span>
            <span class="num">{{displayChosenResearchGroup.researchGroupNo}}</span>
          </div>
          <div class="block_2" @click="toggleShowChooseBox">
            <svg class="icon iconzhuanrang" width="4vw" height="4vw" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M99.119848 428.002088h828.014506a43.350032 43.350032 0 0 0 43.350032-43.350031 43.248882 43.248882 0 0 0-16.451337-33.957525 43.465632 43.465632 0 0 0-9.219107-8.756707L635.50424 124.869766a43.350032 43.350032 0 1 0-49.809186 70.964002l207.270952 145.461032H99.119848a43.350032 43.350032 0 0 0 0 86.707288zM927.134354 601.07709H99.119848a43.350032 43.350032 0 0 0-43.350032 43.350032 43.205532 43.205532 0 0 0 16.451337 33.9503c2.564877 3.272927 5.635504 6.242405 9.219107 8.756706l309.309701 217.075284a43.313907 43.313907 0 0 0 60.386594-10.584632 43.350032 43.350032 0 0 0-10.577407-60.386595L233.288196 687.777154h693.846158a43.350032 43.350032 0 0 0 0-86.700064z" fill="#929292" /></svg>
            <span class="switchingResearchGroup">切换课题组</span>
          </div>
        </div>
        <span class="info_3">{{displayChosenResearchGroup.firstLevelEnterpriseName}}</span>
        <div class="group_2">
          <span class="character">组长：<span class="character-name">{{displayChosenResearchGroup.leaderName}}</span></span>
          <span class="character">审批人：<span class="character-name">{{displayChosenResearchGroup.approverName}}</span></span>
          <span class="character">对账人：<span class="character-name">{{displayChosenResearchGroup.accountCustomerName}}</span></span>
        </div>
      </div>
      <div class="content-block">
      <div class="main" v-if="researchGroupCharacter === 'leader' || researchGroupCharacter === 'approver'">
        <div class="container_4">
          <span class="info_8" :lines="undefined">课题组订单</span>
          <div class="block_7" @click="toOrder(1)">
            <svg width="14px" height="15px" viewBox="0 0 14 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
              <title>订单备份 2</title>
              <desc>Created with Sketch.</desc>
              <g id="课题组" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="主界面" transform="translate(-247.000000, -426.000000)" fill="#979797" fill-rule="nonzero">
                  <g id="编组-3#group#" transform="translate(236.000000, 419.000000)">
                    <g id="订单备份-2" transform="translate(11.000000, 7.000000)">
                      <path d="M2.27230273,15 L2.27230273,15 C1.01805605,14.9984262 0.00171999101,14.0668211 0,12.9171431 L0,2.08285318 L0,2.08291935 C0.00167718208,0.933241334 1.01798443,0.00160772079 2.27223452,0 L11.7276972,0 L11.7276973,0 C12.981944,0.00157386508 13.99828,0.933178898 14,2.08285691 L14,12.9157108 L14,12.9156447 C13.9983228,14.0653227 12.9820156,14.9969563 11.7277655,14.998564 L2.27230273,15 Z M2.27230273,0.917146346 L2.27230279,0.917146346 C1.56943517,0.917933451 0.999860992,1.44002085 0.999002708,2.0842892 L0.999002708,12.9171431 L0.999002708,12.9171131 C0.99984338,13.5613814 1.56940107,14.0834817 2.27227039,14.0842856 L11.7277331,14.0842856 L11.7277331,14.0842856 C12.4306007,14.0834985 13.0001748,13.5614111 13.0010659,12.9171427 L13.0010659,2.08285282 L13.0010659,2.08288286 C13.0002252,1.43861451 12.4306675,0.916514206 11.7277982,0.915710346 L2.27230273,0.917146346 Z" id="形状"></path>
                      <path d="M3.59076309,6.9356706 L3.59076312,6.9356706 C3.30111122,6.94909507 3.05318119,6.76522655 3.03699665,6.52498819 C3.02081095,6.28474983 3.24249855,6.07911575 3.53215045,6.06569222 C3.55167311,6.06478741 3.57124135,6.06478741 3.59076401,6.06569222 L11.4454007,6.06569222 L11.4454007,6.06569222 C11.7350526,6.05226776 11.9829826,6.23613627 11.9991672,6.47637463 C12.0153529,6.71661299 11.7936653,6.92224708 11.5040134,6.9356706 C11.4844907,6.93657541 11.4649225,6.93657541 11.4453998,6.9356706 L3.59076309,6.9356706 Z M3.59076309,8.99321262 L3.59076313,8.99321262 C3.30291885,9.02318376 3.04028113,8.8539443 3.0041466,8.61520519 C2.96801083,8.37646607 3.17206038,8.15863337 3.45990466,8.12866326 C3.50335388,8.12413918 3.5473148,8.12413918 3.59076402,8.12866325 L8.94991953,8.12866325 L8.9499195,8.12866325 C9.24002196,8.12866324 9.47519852,8.32371808 9.47519852,8.56433163 C9.47519852,8.80494369 9.24002375,9 8.9499195,9 L3.59076309,8.99321262 Z M3.59076309,4.87133675 L3.59076307,4.87133675 C3.30066061,4.87133675 3.06548405,4.67628192 3.06548405,4.43566837 C3.06548405,4.19505631 3.30065882,4 3.59076307,4 L11.4453998,4 L11.4453998,4 C11.7355022,4 11.9706788,4.19505483 11.9706788,4.43566837 C11.9706788,4.67628043 11.735504,4.87133675 11.4453998,4.87133675 L3.59076309,4.87133675 Z" id="形状"></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
            <span class="text_4" :lines="undefined">全部订单</span>
          </div>
        </div>
        <div class="empty" />
        <div class="block_8">
          <div class="group_7" @click="toOrder(2)">
            <svg width="35px" height="31px" viewBox="0 0 35 31" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
              <title>daifukuan备份 2#merge#</title>
              <desc>Created with Sketch.</desc>
              <g id="课题组" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="主界面" transform="translate(-63.000000, -472.000000)" fill-rule="nonzero">
                  <g id="daifukuan备份-2#merge#" transform="translate(63.000000, 472.000000)">
                    <path d="M5.84192864,7.27272727 L28.0786574,6.28335089 L30.5319149,6.28335089 L28.5596029,2.16652355 C27.8814262,0.508238737 25.9899977,-0.364382716 24.1782083,0.14459579 L3.72340426,6.28335089 L5.84192864,7.27272727 L5.84192864,7.27272727 Z" id="路径" fill="#333333"></path>
                    <path d="M29.853125,5.54545455 C32.695625,5.54545455 35,7.7369697 35,10.4406061 L35,14.029697 L27.75375,14.030303 C25.36375,14.030303 23.408125,15.8375758 23.335625,18.0878788 L23.333125,18.2345455 C23.333125,20.5072727 25.233125,22.3672727 27.6,22.4357576 L27.75375,22.4381818 L35,22.4381818 L35,26.1048485 C35,28.8078788 32.695625,31 29.853125,31 L5.146875,31 C2.304375,31 0,28.8084848 0,26.1048485 L0,10.4406061 C0,7.73757576 2.304375,5.54545455 5.146875,5.54545455 L29.853125,5.54545455 Z" id="路径" fill="#5878FA"></path>
                    <path d="M24.5744681,18.2727273 C24.5744681,19.678543 25.7413855,20.8181818 27.1808511,20.8181818 C28.6203166,20.8181818 29.787234,19.678543 29.787234,18.2727273 C29.787234,16.8669115 28.6203166,15.7272727 27.1808511,15.7272727 C25.7413855,15.7272727 24.5744681,16.8669115 24.5744681,18.2727273 Z" id="路径" fill="#333333"></path>
                  </g>
                </g>
              </g>
            </svg>
            <span class="txt_7" :lines="undefined">待审批</span>
          </div>
          <div class="colorDiv_4" v-if="orderList.waitApprovedOrderList && orderList.waitApprovedOrderList.length>0">
            {{orderList.waitApprovedOrderList.length}}
          </div>
          <div class="container_51" @click="toOrder(3)">
            <svg class="icon" width="15vw" height="15vw" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M634.08 64H389.872C359.936 64 336 87.008 336 115.456c0 28.496 24 51.568 53.888 51.568h245.696C664 167.04 688 143.952 688 115.456 688 87.008 664.048 64 634.08 64z" fill="#333333" /><path d="M304.464 98.336a117.6 117.6 0 0 0-1.536 17.968c0 45.472 27.936 90.208 62.832 90.208h302.32c33.168 0 61.056-44.736 61.024-90.208 0-6.064-0.544-12.048-1.488-17.968h96.896C894.56 98.336 928 149.184 928 222.512v614.528c0 88.272-35.728 122.832-109.232 122.832H196.176C122.672 959.872 96 915.792 96 836.992V222.528c0-73.328 18.624-124.16 94.448-124.16z m391.536 624h-368a40 40 0 1 0 0 80h368a40 40 0 1 0 0-80z m0-192h-368a40 40 0 1 0 0 80h368a40 40 0 1 0 0-80z m0-192h-368a40 40 0 1 0 0 80h368a40 40 0 1 0 0-80z" fill="#5878FA" /></svg>
            <span class="word_5" :lines="undefined">执行中</span>
          </div>
          <div class="outer_4" @click="toOrder(4)">
            <svg width="33px" height="32px" viewBox="0 0 33 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
              <title>yiwancheng备份 2#merge#</title>
              <desc>Created with Sketch.</desc>
              <g id="课题组" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="主界面" transform="translate(-280.000000, -471.000000)" fill-rule="nonzero">
                  <g id="yiwancheng备份-2#merge#" transform="translate(280.000000, 471.000000)">
                    <path d="M4.51392857,1.44680851 L8.71435714,1.44680851 C9.293625,1.44680851 9.73676786,1.98033362 9.68078571,2.58009362 L9.64601786,2.81708085 C9.63423214,2.9124834 9.62833929,3.00424 9.62775,3.09052766 C9.62775,4.16608511 10.3378393,5.12314894 11.0143393,5.12314894 L21.75525,5.12314894 C22.3710536,5.12314894 23.0746607,4.15575489 23.0740714,3.09052766 C23.0740714,3.00241702 23.0681786,2.91126809 23.0563929,2.81647319 L23.0222143,2.58009362 C22.9662321,1.98033362 23.409375,1.44680851 23.9886429,1.44680851 L28.1466429,1.44680851 C31.2109286,1.44680851 33,3.51832 33,6.70002553 L33,26.6221447 C33,30.1392783 31.2816429,31.8297872 27.9321429,31.8297872 L4.72783929,31.8297872 C1.53685714,31.8297872 0,29.997086 0,26.6209294 L0,6.70002553 C0,3.3153617 1.332375,1.44680851 4.51392857,1.44680851 Z" id="路径" fill="#5878FA"></path>
                    <path d="M12.226081,0 C11.2844749,0 10.5319149,0.807801418 10.5319149,1.80609929 C10.5319149,2.80680851 11.2862869,3.61702128 12.226081,3.61702128 L20.1176939,3.61702128 C21.0115854,3.61702128 21.7659574,2.80680851 21.7659574,1.80609929 C21.7659574,0.807801418 21.0133974,0 20.0699794,0 L12.226081,0 Z" id="路径" fill="#333333"></path>
                    <path d="M15.6094306,22.4255319 C15.2653615,22.4257077 14.9354445,22.2902224 14.6928646,22.0491303 L9.50701454,16.9049774 C9.00120792,16.4014043 9.00120792,15.5889796 9.50701454,15.0854065 C9.74964249,14.8443648 10.0795137,14.7088382 10.4235806,14.7088382 C10.7676475,14.7088382 11.0975187,14.8443648 11.3401466,15.0854065 L15.6094306,19.3209632 L23.7664471,11.2286297 C24.0087567,10.9869985 24.3387472,10.8510638 24.6830132,10.8510638 C25.0272792,10.8510638 25.3572696,10.9869985 25.5995792,11.2286297 C26.1051048,11.7304983 26.1051048,12.5439535 25.5995792,13.0464167 L16.5259967,22.0491303 C16.2832654,22.2899995 15.9534466,22.4255319 15.6094306,22.4255319 L15.6094306,22.4255319 Z" id="路径" fill="#FFFFFF"></path>
                  </g>
                </g>
              </g>
            </svg>
            <span class="text_5" :lines="undefined">已完成</span>
          </div>
        </div>
        <div class="group_8" v-if="orderList.waitApprovedOrderList&& orderList.waitApprovedOrderList.length>0">
          <svg class="anonymousIconfont" width="200px" height="200.00px" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M512 4.12672c280.49408 0 507.87328 227.3792 507.87328 507.87328 0 280.49408-227.3792 507.87328-507.87328 507.87328C231.50592 1019.87328 4.12672 792.49408 4.12672 512 4.12672 231.50592 231.50592 4.12672 512 4.12672zM512 685.96736c-42.47552 0-76.91264 34.42688-76.91264 76.91264 0 42.47552 34.43712 76.91264 76.91264 76.91264 42.47552 0 76.91264-34.43712 76.91264-76.91264C588.91264 720.39424 554.47552 685.96736 512 685.96736zM509.78816 625.83808c36.58752 0 66.24256-29.66528 66.24256-66.24256l0-309.1456c0-36.58752-29.65504-66.24256-66.24256-66.24256-36.58752 0-66.24256 29.66528-66.24256 66.24256l0 309.1456C443.5456 596.18304 473.20064 625.83808 509.78816 625.83808z" fill="#FE654D" /></svg>
          <span class="desc" :lines="undefined"
          >您有{{orderList.waitApprovedOrderList.length}}个订单需要审批，请尽快审批</span
          >
        </div>
      </div>
      <!-- 对账人和组长可以看到对账单 -->
      <!--      <div class="bill_detail" :class="[researchGroupCharacter === 'leader' || researchGroupCharacter === 'approver'?'existOrder':'unexistOrder']"v-if="researchGroupCharacter === 'leader' || customerNo === displayChosenResearchGroup.accountCustomerNo">-->
      <!--        <div class="container_3" v-if="billInfo && billInfo.summary ">-->
      <!--          <div class="priceWrap">-->
      <!--            <span class="info_4">上月待付账单</span>-->
      <!--            <span class="price">¥{{billInfo.summary.balanceAmount && splitMoney(billInfo.summary.balanceAmount.toFixed(2))}}</span>-->
      <!--          </div>-->
      <!--          <div class="block_2" @click="checkBill">-->
      <!--            <svg class="icon iconzhuanrang" width="4vw" height="4vw" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M708.928 96C767.248 96 816 139.68 816 195.28v527.84c0 53.76-45.712 96.672-102.768 99.2l-4.272 0.08H203.072C144.752 822.4 96 778.72 96 723.12v-527.84C96 139.68 144.752 96 203.072 96h505.856z m0 76.8H203.072c-16.64 0-28.848 10.944-28.848 22.48v527.84c0 11.52 12.208 22.48 28.848 22.48h504.992l2.512-0.032c15.856-0.704 27.2-11.36 27.2-22.464V195.28c0-11.52-12.208-22.48-28.848-22.48z" fill="#929292" /><path d="M893.84 192c18.88 0 34.16 15.136 34.16 33.808v591.2C928 878.192 877.696 928 815.84 928H370.176A33.984 33.984 0 0 1 336 894.192c0-18.656 15.296-33.792 34.16-33.792H815.84c24.16 0 43.84-19.472 43.84-43.408v-591.2c0-18.656 15.28-33.792 34.144-33.792zM553.408 250.368c17.44 0 30.592 15.744 30.592 34.112 0 18.4-13.136 34.128-30.592 34.128H281.792c-17.456 0-30.592-15.744-30.592-34.128 0-18.368 13.136-34.112 30.592-34.112h271.616z" fill="#929292" /><path d="M629.952 422.4c17.552 0 30.848 15.712 30.848 34.112 0 18.416-13.28 34.128-30.848 34.128H282.048c-17.552 0-30.848-15.712-30.848-34.128 0-18.4 13.28-34.112 30.848-34.112h347.904zM629.952 601.6c17.552 0 30.848 15.712 30.848 34.112 0 18.416-13.28 34.128-30.848 34.128H282.048c-17.552 0-30.848-15.712-30.848-34.128 0-18.4 13.28-34.112 30.848-34.112h347.904z" fill="#929292" /></svg>-->
      <!--            <span class="switchingResearchGroup">查看对账单</span>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class="block_3" v-if="billInfo && billInfo.summary ">-->
      <!--          <div class="moneyWrap">-->
      <!--            <span class="info_5">上月消费金额</span>-->
      <!--            <span class="money">¥{{billInfo.summary.consumedMoneySum && splitMoney(billInfo.summary.consumedMoneySum.toFixed(2))}}</span>-->
      <!--          </div>-->
      <!--          <div class="moneyWrap">-->
      <!--            <span class="info_5">上月交付金额</span>-->
      <!--            <span class="money">¥{{billInfo.summary.deliveryMoneySum && splitMoney(billInfo.summary.deliveryMoneySum.toFixed(2))}}</span>-->
      <!--          </div>-->
      <!--        </div>-->

      <!--        <div class="group_4" v-if="billInfo && billInfo.statementGuid && !billInfo.confirmDT">-->
      <!--          <svg class="anonymousIconfont" width="200px" height="200.00px" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M512 4.12672c280.49408 0 507.87328 227.3792 507.87328 507.87328 0 280.49408-227.3792 507.87328-507.87328 507.87328C231.50592 1019.87328 4.12672 792.49408 4.12672 512 4.12672 231.50592 231.50592 4.12672 512 4.12672zM512 685.96736c-42.47552 0-76.91264 34.42688-76.91264 76.91264 0 42.47552 34.43712 76.91264 76.91264 76.91264 42.47552 0 76.91264-34.43712 76.91264-76.91264C588.91264 720.39424 554.47552 685.96736 512 685.96736zM509.78816 625.83808c36.58752 0 66.24256-29.66528 66.24256-66.24256l0-309.1456c0-36.58752-29.65504-66.24256-66.24256-66.24256-36.58752 0-66.24256 29.66528-66.24256 66.24256l0 309.1456C443.5456 596.18304 473.20064 625.83808 509.78816 625.83808z" fill="#FE654D" /></svg>-->
      <!--          <span class="desc">您有待付账单需要核对，请查看对账单</span>-->
      <!--        </div>-->
      <!--        <div class="group_4" v-else>-->
      <!--          <svg class="anonymousIconfont" width="200px" height="200.00px" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M512 1024C229.248 1024 0 794.752 0 512S229.248 0 512 0s512 229.248 512 512-229.248 512-512 512z m-114.176-310.954667a53.333333 53.333333 0 0 0 75.434667 0l323.328-323.328a53.333333 53.333333 0 1 0-75.434667-75.434666l-287.914667 283.306666-128.853333-128.853333a53.333333 53.333333 0 1 0-75.434667 75.434667l168.874667 168.874666z" fill="#60D837" /></svg>-->
      <!--          <span class="desc_2">您没有账单需要核对，感谢您对吉凯基因的支持！</span>-->
      <!--        </div>-->
      <!--        &lt;!&ndash;<div class="container_3">&ndash;&gt;-->
      <!--          &lt;!&ndash;<div class="outer_2">&ndash;&gt;-->
      <!--            &lt;!&ndash;<span class="currentBill">本期账单</span>&ndash;&gt;-->
      <!--            &lt;!&ndash;<span class="info_4">账单日2月5日</span>&ndash;&gt;-->
      <!--          &lt;!&ndash;</div>&ndash;&gt;-->
      <!--          &lt;!&ndash;<div class="block_2">&ndash;&gt;-->
      <!--            &lt;!&ndash;<svg class="icon iconzhuanrang" width="4vw" height="4vw" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M708.928 96C767.248 96 816 139.68 816 195.28v527.84c0 53.76-45.712 96.672-102.768 99.2l-4.272 0.08H203.072C144.752 822.4 96 778.72 96 723.12v-527.84C96 139.68 144.752 96 203.072 96h505.856z m0 76.8H203.072c-16.64 0-28.848 10.944-28.848 22.48v527.84c0 11.52 12.208 22.48 28.848 22.48h504.992l2.512-0.032c15.856-0.704 27.2-11.36 27.2-22.464V195.28c0-11.52-12.208-22.48-28.848-22.48z" fill="#929292" /><path d="M893.84 192c18.88 0 34.16 15.136 34.16 33.808v591.2C928 878.192 877.696 928 815.84 928H370.176A33.984 33.984 0 0 1 336 894.192c0-18.656 15.296-33.792 34.16-33.792H815.84c24.16 0 43.84-19.472 43.84-43.408v-591.2c0-18.656 15.28-33.792 34.144-33.792zM553.408 250.368c17.44 0 30.592 15.744 30.592 34.112 0 18.4-13.136 34.128-30.592 34.128H281.792c-17.456 0-30.592-15.744-30.592-34.128 0-18.368 13.136-34.112 30.592-34.112h271.616z" fill="#929292" /><path d="M629.952 422.4c17.552 0 30.848 15.712 30.848 34.112 0 18.416-13.28 34.128-30.848 34.128H282.048c-17.552 0-30.848-15.712-30.848-34.128 0-18.4 13.28-34.112 30.848-34.112h347.904zM629.952 601.6c17.552 0 30.848 15.712 30.848 34.112 0 18.416-13.28 34.128-30.848 34.128H282.048c-17.552 0-30.848-15.712-30.848-34.128 0-18.4 13.28-34.112 30.848-34.112h347.904z" fill="#929292" /></svg>&ndash;&gt;-->
      <!--            &lt;!&ndash;<span class="switchingResearchGroup">查看对账单</span>&ndash;&gt;-->
      <!--          &lt;!&ndash;</div>&ndash;&gt;-->
      <!--        &lt;!&ndash;</div>&ndash;&gt;-->
      <!--        &lt;!&ndash;<div class="block_3">&ndash;&gt;-->
      <!--          &lt;!&ndash;<svg width="29px" height="26px" viewBox="0 0 29 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">&ndash;&gt;-->
      <!--              &lt;!&ndash;<title>tubiaozhizuo-</title>&ndash;&gt;-->
      <!--              &lt;!&ndash;<desc>Created with Sketch.</desc>&ndash;&gt;-->
      <!--              &lt;!&ndash;<g id="课题组" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">&ndash;&gt;-->
      <!--                  &lt;!&ndash;<g id="课题组管理" transform="translate(-117.000000, -370.000000)" fill="#FF9400" fill-rule="nonzero">&ndash;&gt;-->
      <!--                      &lt;!&ndash;<g id="编组-2" transform="translate(25.000000, 308.000000)">&ndash;&gt;-->
      <!--                          &lt;!&ndash;<g id="tubiaozhizuo-" transform="translate(92.000000, 62.000000)">&ndash;&gt;-->
      <!--                              &lt;!&ndash;<path d="M14.5006516,17.8751461 C6.49160363,17.8751461 0,16.2003371 0,13.5080225 L0,16.25 C0,18.9426067 6.49203805,21.1248539 14.5006516,21.1248539 C22.5092652,21.1248539 28.9982627,18.9426067 28.9982627,16.25 L28.9982627,13.5080225 C29,16.2003371 22.5096996,17.8751461 14.5006516,17.8751461 Z M14.5006516,22.75 C6.49160363,22.75 0,21.075191 0,18.3828764 L0,21.1248539 C0.00130327316,23.8177528 6.49334132,26 14.5006516,26 C22.507962,26 28.9982627,23.8177528 28.9982627,21.1251461 L28.9982627,18.3831685 C29,21.075191 22.5096996,22.7502921 14.5006516,22.7502921 L14.5006516,22.75 Z M14.5006516,13 C6.49160363,13 0,11.3254831 0,8.6328764 L0,11.3751461 C0,14.0674607 6.49203805,16.25 14.5006516,16.25 C22.5092652,16.25 28.9982627,14.0671685 28.9982627,11.3751461 L28.9982627,8.6328764 C29,11.3254831 22.5096996,13 14.5006516,13 Z M14.5006516,0 C6.49160363,0 0,2.18253933 0,4.87514607 L0,6.5 C0,9.19260674 6.49203805,11.3751461 14.5006516,11.3751461 C22.5092652,11.3751461 29,9.19260674 29,6.5 L29,4.87514607 C29,2.18253933 22.5096996,0 14.5006516,0 Z" id="形状"></path>&ndash;&gt;-->
      <!--                          &lt;!&ndash;</g>&ndash;&gt;-->
      <!--                      &lt;!&ndash;</g>&ndash;&gt;-->
      <!--                  &lt;!&ndash;</g>&ndash;&gt;-->
      <!--              &lt;!&ndash;</g>&ndash;&gt;-->
      <!--          &lt;!&ndash;</svg>   &ndash;&gt;-->
      <!--          &lt;!&ndash;<span class="text">{{splitMoney(monthlyBillInfo.billAmount)}}</span>&ndash;&gt;-->
      <!--        &lt;!&ndash;</div>&ndash;&gt;-->
      <!--        &lt;!&ndash;<div class="group_4">&ndash;&gt;-->
      <!--          &lt;!&ndash;<span class="consumption">消费：<span class="word research-font-color">{{splitMoney(monthlyBillInfo.consumedMoneySum)}}</span></span>&ndash;&gt;-->
      <!--          &lt;!&ndash;<span class="consumption">交付：<span class="word research-font-color">{{splitMoney(monthlyBillInfo.deliveryMoney)}}</span></span>&ndash;&gt;-->
      <!--          &lt;!&ndash;<span class="consumption">未清：<span class="word research-font-color">{{splitMoney(monthlyBillInfo.balanceAmount)}}</span></span>&ndash;&gt;-->
      <!--        &lt;!&ndash;</div>&ndash;&gt;-->
      <!--      </div>-->
      <!--      <div v-else style="margin-top: 76.53vw;"></div>-->
      <!-- 组长的管理功能 -->
      <div class="management" v-if="researchGroupCharacter === 'leader'">
        <span class="managementTools">管理工具</span>
        <div class="container_5">
          <!--          <router-link class="outer_3" :to="{name:'ApproveOrder', query: {researchGroupNo: displayChosenResearchGroup.researchGroupNo}}">-->
          <!--            <svg class="icon" width="15vw" height="15vw" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M634.08 64H389.872C359.936 64 336 87.008 336 115.456c0 28.496 24 51.568 53.888 51.568h245.696C664 167.04 688 143.952 688 115.456 688 87.008 664.048 64 634.08 64z" fill="#333333" /><path d="M304.464 98.336a117.6 117.6 0 0 0-1.536 17.968c0 45.472 27.936 90.208 62.832 90.208h302.32c33.168 0 61.056-44.736 61.024-90.208 0-6.064-0.544-12.048-1.488-17.968h96.896C894.56 98.336 928 149.184 928 222.512v614.528c0 88.272-35.728 122.832-109.232 122.832H196.176C122.672 959.872 96 915.792 96 836.992V222.528c0-73.328 18.624-124.16 94.448-124.16z m391.536 624h-368a40 40 0 1 0 0 80h368a40 40 0 1 0 0-80z m0-192h-368a40 40 0 1 0 0 80h368a40 40 0 1 0 0-80z m0-192h-368a40 40 0 1 0 0 80h368a40 40 0 1 0 0-80z" fill="#5878FA" /></svg>-->
          <!--            <span class="setUpReconcilingPerson">审批订单</span>-->
          <!--            <span class="orderNum" v-if="waitApproveOrderNum">{{waitApproveOrderNum}}</span>-->
          <!--          </router-link>-->
          <router-link class="outer_3" :to="{name:'ResearchGroupDetail'}">
            <svg class="icon" width="15vw" height="15vw" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M350.88 484.528h-108.192c-76.704 0-139.648-62.784-139.648-139.328v-109.872C103.04 158.8 165.984 96 242.688 96h108.176c76.72 0 139.664 62.8 139.664 139.328v107.92c1.952 78.496-60.976 141.28-139.664 141.28z m444.512 0H687.2c-76.72 0-139.648-62.784-139.648-139.328v-109.872C547.568 158.8 610.496 96 687.2 96h108.16c76.72 0 139.664 62.8 139.664 139.328v107.92c0 78.496-62.944 141.28-139.648 141.28zM350.864 928h-108.16c-76.72 0-139.664-62.784-139.664-139.312v-107.92c0-76.528 62.944-139.328 139.648-139.328h108.176c76.72 0 139.664 62.8 139.664 139.328v107.92C492.48 865.216 429.552 928 350.864 928z" fill="#5878FA" /><path d="M886.48 634.176H597.568c-16.288 0-30.528-13.568-30.528-29.088 0-15.52 14.24-29.088 30.528-29.088h290.944c16.288 0 30.528 13.584 30.528 29.088 0 15.52-16.272 29.088-32.56 29.088z m-48.832 129.952H597.568c-16.288 0-30.528-13.584-30.528-29.104s14.24-29.088 30.528-29.088h240.08c16.288 0 30.528 13.584 30.528 29.088 0 15.52-14.24 29.104-30.528 29.104zM717.6 896h-120.032c-16.288 0-30.528-13.568-30.528-29.088 0-15.52 14.24-29.088 30.528-29.088h120.032c16.288 0 30.528 13.568 30.528 29.088 0 15.52-14.24 29.088-30.528 29.088z" fill="#333333" /></svg>
            <span class="setUpReconcilingPerson">课题组信息</span>
          </router-link>
          <router-link class="outer_3" :to="{name:'ResearchMemberManagement'}">
            <svg class="icon" width="15vw" height="15vw" viewBox="0 0 1040 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M401.1 312.7m-193.8 0a193.8 193.8 0 1 0 387.6 0 193.8 193.8 0 1 0-387.6 0Z" fill="#5878FA" /><path d="M738.9 833.2c0 169.3-675.5 169.3-675.5 0S214.6 562 401.1 562s337.8 101.9 337.8 271.2zM644.7 63.5c-47.2 0-90.4 16.9-124 44.9 75.3 36.5 127.4 113.5 127.4 202.9 0 50.8-17 97.5-45.3 135.2 13.5 3 27.4 4.6 41.8 4.6 107 0 193.8-86.8 193.8-193.8S751.8 63.5 644.7 63.5z" fill="#5878FA" /><path d="M622.6 513.2c-20.4 0-83.1 6.1-104.2 16.1 131.8 26.8 275.1 129.3 275.1 293.1 0 25.6-10.4 48.2-28.7 67.9 110.1-18 195.5-58.2 195.5-120.6 0.1-175.4-151.2-256.5-337.7-256.5z" fill="#5878FA" /></svg>
            <span class="setUpReconcilingPerson">成员管理</span>
            <div class="colorDiv_Member" v-if="approvalMemberListLength > 0">
              {{approvalMemberListLength}}
            </div>
          </router-link>
          <router-link class="outer_3" :to="{name:'ResearchMemberCharacterSetting', query:{character:'accountCustomer'}}">
            <svg class="icon" width="15vw" height="15vw" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M219.232 287.872l571.84-26.032h63.088l-50.72-108.32c-17.44-43.632-66.08-66.592-112.672-53.2L164.752 261.84l54.48 26.032z" fill="#333333" /><path d="M828.24 256C901.008 256 960 313.856 960 385.232v94.752L774.496 480c-61.184 0-111.248 47.712-113.104 107.12l-0.064 3.872c0 60 48.64 109.104 109.232 110.912l3.936 0.064H960v96.8C960 870.128 901.008 928 828.24 928H195.76C122.992 928 64 870.144 64 798.768V385.232C64 313.872 122.992 256 195.76 256h632.48z" fill="#5878FA" /><path d="M768 592m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z" fill="#333333" /></svg>
            <span class="setUpReconcilingPerson">设置对账人</span>
          </router-link>
        </div>
        <div class="container_5">
          <router-link class="outer_3" :to="{name:'ResearchMemberCharacterSetting', query:{character:'approver'}}">
            <svg class="icon" width="15vw" height="15vw" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M645.488 544c3.552 9.776 5.328 20.032 5.28 30.352v96.208c0.064 25.568-10.848 50.112-30.32 68.208-19.488 18.096-45.952 28.272-73.552 28.272h-70.976c-27.584 0-54.048-10.176-73.536-28.272-19.488-18.096-30.4-42.64-30.304-68.208v-96.208c-0.016-10.288 1.664-20.528 4.96-30.352C222 582.48 96 679.52 96 791.168v72.352c0.16 53.12 46.512 96.176 103.84 96.48h624.32c57.328-0.304 103.68-43.36 103.84-96.48v-72.352c0-112.48-126-208.688-281.344-247.168h-1.168z m-134-32C635.488 512 736 411.632 736 288.112 736 164.592 636.496 64 512.512 64 388.512 64 288 164.368 288 288.112S389.008 512 512.512 512h-1.024z" fill="#5878FA" /><path d="M512 544c-26.512 0-48 23.92-48 53.44v53.12c0 29.52 21.488 53.44 48 53.44s48-23.92 48-53.44v-53.12c0.016-14.192-5.024-27.792-14.016-37.824-8.8-9.648-20.56-15.232-32.912-15.616H512z" fill="#333333" /></svg>
            <span class="setUpReconcilingPerson">设置审批人</span>
          </router-link>
<!--          <div class="outer_3"></div>-->
          <router-link class="outer_3" :to="{name:'ResearchMemberCharacterSetting', query:{character:'horMember'}}">
            <svg class="icon" width="15vw" height="15vw" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M645.488 544c3.552 9.776 5.328 20.032 5.28 30.352v96.208c0.064 25.568-10.848 50.112-30.32 68.208-19.488 18.096-45.952 28.272-73.552 28.272h-70.976c-27.584 0-54.048-10.176-73.536-28.272-19.488-18.096-30.4-42.64-30.304-68.208v-96.208c-0.016-10.288 1.664-20.528 4.96-30.352C222 582.48 96 679.52 96 791.168v72.352c0.16 53.12 46.512 96.176 103.84 96.48h624.32c57.328-0.304 103.68-43.36 103.84-96.48v-72.352c0-112.48-126-208.688-281.344-247.168h-1.168z m-134-32C635.488 512 736 411.632 736 288.112 736 164.592 636.496 64 512.512 64 388.512 64 288 164.368 288 288.112S389.008 512 512.512 512h-1.024z" fill="#5878FA" /><path d="M512 544c-26.512 0-48 23.92-48 53.44v53.12c0 29.52 21.488 53.44 48 53.44s48-23.92 48-53.44v-53.12c0.016-14.192-5.024-27.792-14.016-37.824-8.8-9.648-20.56-15.232-32.912-15.616H512z" fill="#333333" /></svg>
            <span class="setUpReconcilingPerson">设置科研者之家会员</span>
          </router-link>
          <div class="outer_3"></div>
        </div>
      </div>
      <!-- 非组长的审批人功能 -->
      <div class="management" v-else-if="researchGroupCharacter === 'approver'">
        <span class="managementTools">管理工具</span>
        <div class="container_51">
          <!--          <router-link class="outer_3" :to="{name:'ApproveOrder'}">-->
          <!--            <svg class="icon" width="15vw" height="15vw" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M634.08 64H389.872C359.936 64 336 87.008 336 115.456c0 28.496 24 51.568 53.888 51.568h245.696C664 167.04 688 143.952 688 115.456 688 87.008 664.048 64 634.08 64z" fill="#333333" /><path d="M304.464 98.336a117.6 117.6 0 0 0-1.536 17.968c0 45.472 27.936 90.208 62.832 90.208h302.32c33.168 0 61.056-44.736 61.024-90.208 0-6.064-0.544-12.048-1.488-17.968h96.896C894.56 98.336 928 149.184 928 222.512v614.528c0 88.272-35.728 122.832-109.232 122.832H196.176C122.672 959.872 96 915.792 96 836.992V222.528c0-73.328 18.624-124.16 94.448-124.16z m391.536 624h-368a40 40 0 1 0 0 80h368a40 40 0 1 0 0-80z m0-192h-368a40 40 0 1 0 0 80h368a40 40 0 1 0 0-80z m0-192h-368a40 40 0 1 0 0 80h368a40 40 0 1 0 0-80z" fill="#5878FA" /></svg>-->
          <!--            <span class="setUpReconcilingPerson">审批订单</span>-->
          <!--            <span class="orderNum" v-if="waitApproveOrderNum">{{waitApproveOrderNum}}</span>-->
          <!--          </router-link>-->
          <!--          <router-link class="outer_3" :to="{name:'ResearchGroupDetail'}">-->
          <!--            <svg class="icon" width="15vw" height="15vw" viewBox="0 0 1040 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M350.88 484.528h-108.192c-76.704 0-139.648-62.784-139.648-139.328v-109.872C103.04 158.8 165.984 96 242.688 96h108.176c76.72 0 139.664 62.8 139.664 139.328v107.92c1.952 78.496-60.976 141.28-139.664 141.28z m444.512 0H687.2c-76.72 0-139.648-62.784-139.648-139.328v-109.872C547.568 158.8 610.496 96 687.2 96h108.16c76.72 0 139.664 62.8 139.664 139.328v107.92c0 78.496-62.944 141.28-139.648 141.28zM350.864 928h-108.16c-76.72 0-139.664-62.784-139.664-139.312v-107.92c0-76.528 62.944-139.328 139.648-139.328h108.176c76.72 0 139.664 62.8 139.664 139.328v107.92C492.48 865.216 429.552 928 350.864 928z" fill="#5878FA" /><path d="M886.48 634.176H597.568c-16.288 0-30.528-13.568-30.528-29.088 0-15.52 14.24-29.088 30.528-29.088h290.944c16.288 0 30.528 13.584 30.528 29.088 0 15.52-16.272 29.088-32.56 29.088z m-48.832 129.952H597.568c-16.288 0-30.528-13.584-30.528-29.104s14.24-29.088 30.528-29.088h240.08c16.288 0 30.528 13.584 30.528 29.088 0 15.52-14.24 29.104-30.528 29.104zM717.6 896h-120.032c-16.288 0-30.528-13.568-30.528-29.088 0-15.52 14.24-29.088 30.528-29.088h120.032c16.288 0 30.528 13.568 30.528 29.088 0 15.52-14.24 29.088-30.528 29.088z" fill="#333333" /></svg>-->
          <!--            <span class="setUpReconcilingPerson">课题组信息</span>-->
          <!--          </router-link>-->
          <router-link class="outer_3" :to="{name:'ResearchGroupDetail'}">
            <svg class="icon" width="15vw" height="15vw" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M634.08 64H389.872C359.936 64 336 87.008 336 115.456c0 28.496 24 51.568 53.888 51.568h245.696C664 167.04 688 143.952 688 115.456 688 87.008 664.048 64 634.08 64z" fill="#333333" /><path d="M304.464 98.336a117.6 117.6 0 0 0-1.536 17.968c0 45.472 27.936 90.208 62.832 90.208h302.32c33.168 0 61.056-44.736 61.024-90.208 0-6.064-0.544-12.048-1.488-17.968h96.896C894.56 98.336 928 149.184 928 222.512v614.528c0 88.272-35.728 122.832-109.232 122.832H196.176C122.672 959.872 96 915.792 96 836.992V222.528c0-73.328 18.624-124.16 94.448-124.16z m391.536 624h-368a40 40 0 1 0 0 80h368a40 40 0 1 0 0-80z m0-192h-368a40 40 0 1 0 0 80h368a40 40 0 1 0 0-80z m0-192h-368a40 40 0 1 0 0 80h368a40 40 0 1 0 0-80z" fill="#5878FA" /></svg>
            <span class="setUpReconcilingPerson">课题组信息</span>
          </router-link>
          <div class="outer_3"></div>
        </div>
      </div>
      <!-- 普通组员只能看到课题组信息 -->
      <div class="management" v-else>
        <span class="managementTools">管理工具</span>
        <div class="container_5">
          <router-link class="outer_3" :to="{name:'ResearchGroupDetail'}">
            <svg class="icon" width="15vw" height="15vw" viewBox="0 0 1040 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M350.88 484.528h-108.192c-76.704 0-139.648-62.784-139.648-139.328v-109.872C103.04 158.8 165.984 96 242.688 96h108.176c76.72 0 139.664 62.8 139.664 139.328v107.92c1.952 78.496-60.976 141.28-139.664 141.28z m444.512 0H687.2c-76.72 0-139.648-62.784-139.648-139.328v-109.872C547.568 158.8 610.496 96 687.2 96h108.16c76.72 0 139.664 62.8 139.664 139.328v107.92c0 78.496-62.944 141.28-139.648 141.28zM350.864 928h-108.16c-76.72 0-139.664-62.784-139.664-139.312v-107.92c0-76.528 62.944-139.328 139.648-139.328h108.176c76.72 0 139.664 62.8 139.664 139.328v107.92C492.48 865.216 429.552 928 350.864 928z" fill="#5878FA" /><path d="M886.48 634.176H597.568c-16.288 0-30.528-13.568-30.528-29.088 0-15.52 14.24-29.088 30.528-29.088h290.944c16.288 0 30.528 13.584 30.528 29.088 0 15.52-16.272 29.088-32.56 29.088z m-48.832 129.952H597.568c-16.288 0-30.528-13.584-30.528-29.104s14.24-29.088 30.528-29.088h240.08c16.288 0 30.528 13.584 30.528 29.088 0 15.52-14.24 29.104-30.528 29.104zM717.6 896h-120.032c-16.288 0-30.528-13.568-30.528-29.088 0-15.52 14.24-29.088 30.528-29.088h120.032c16.288 0 30.528 13.568 30.528 29.088 0 15.52-14.24 29.088-30.528 29.088z" fill="#333333" /></svg>
            <span class="setUpReconcilingPerson">课题组信息</span>
          </router-link>
          <div class="outer_3"></div>
          <div class="outer_3"></div>
        </div>
      </div>
      <div style="height: 10vw; visibility: hidden;">hidden</div>
      </div>

    </div>
    <div class="box_3" v-else>
      <div>
        <img style="width: 275px;" src="/static/img/无课题组提示.png"/>
        <div class="remind-info">
          <span class="remind-title">您还未加入G客课题组~</span>
          <div class="remind-text">
            <span>为您的科研课题组创建专属账户</span>
            <span>享受专属科研服务、更优的折扣</span>
            <span>账户月结、便捷跟踪管理</span>
            <span>联系业务人员或致电<a style="color: #ff9400;" href="tel:400-621-0302">400-621-0302</a></span>
          </div>
        </div>
      </div>
    </div>
    <ChooseResearchGroup v-if="showChooseResearchGroup" @toggleShow="toggleShowChooseBox" />
  </div>

</template>
<script>
import EMKT from '../../../emkt'
import {mapMutations, mapState, mapGetters} from 'vuex'
import ChooseResearchGroup from './researchGroupComponents/ChooseResearchGroup'
import $ from 'jquery'
export default {
  data () {
    return {
      researchGroupApproveTypeDictionary: EMKT.researchGroupApproveTypeDictionary,
      approveTypeThreshold: EMKT.CONSTANT_APPROVETYPE_THRESHOLD,
      approveTypeNone: EMKT.CONSTANT_APPROVETYPE_NONE,
      waitApproveOrderNum: 0,
      showChooseResearchGroup: false,
      billInfo: {},
      isResearchGroup: EMKT.isResearchGroup,
      orderList: {},
      isWapp: EMKT.isWapp,
      approvalMemberList: []
    }
  },
  mounted () {
    console.log('haslogin', this.hasLogin)
    if (this.isResearchGroup && this.hasLogin && EMKT.isNullOrBlankObject(this.displayChosenResearchGroup)) {
      $.showPreloader('加载中')
      setTimeout(() => {
        $.hidePreloader()
      }, 3000)
    }
  },
  components: {
    ChooseResearchGroup
  },
  methods: {
    ...mapMutations([
      'UPDATE_RESEARCHGROUP_ORDER_MAP'
    ]),
    goBack () {
      if (this.isResearchGroup) return
      this.$router.push({name: 'me'})
    },
    isJson (str) {
      try {
        if (typeof JSON.parse(str) === 'object') {
          return true
        }
      } catch (e) {
        console.log('is not Json', e)
      }
      return false
    },
    getWaitApproveOrderNumAndBill () {
      if (!this.hasLogin) {
        $.toast('请登录')
        this.$router.push({name: 'login'})
      }
      if (!this.customerNo || !this.displayChosenResearchGroup) {
        return
      }
      // 00000056
      const queryParam = {}
      queryParam.researchGroupNo = this.displayChosenResearchGroup.researchGroupNo
      if (this.displayChosenResearchGroup) {
        this.gcapi('getAllRequestLogByResearchGroupNo', queryParam.researchGroupNo).then(res => {
          this.approvalMemberList = res.data.result.map(item => ({...item, createDT: item.createDT || EMKT.FormatterTime(new Date())})).filter(item => item.status === 0)
        })
      }
      this.gcapi('getAllOrdersByCustomerNoOrResearchGroupNo', queryParam).then(res => {
        console.log('课题组订单订单信息列表：', res.data.result)
        if (res.data.code === 0) {
          this.orderList = res.data.result
          EMKT.setLocalStorage('ResearchGroupOrderList', this.orderList)
        } else {
          console.log('获取课题组订单信息列表失败')
        }
      })
      console.log('displayChosenResearchGroup', this.displayChosenResearchGroup)
      if (this.customerNo === this.displayChosenResearchGroup.approverNo || this.customerNo === this.displayChosenResearchGroup.leaderNo) {
        this.gcapi('loadWaitingApprovedOrderList', this.displayChosenResearchGroup.researchGroupNo).then(res => {
          if (res && res.body.result) {
            this.waitApproveOrderNum = res.body.result.length
          }
        })
      }
      if (this.customerNo === this.displayChosenResearchGroup.accountCustomerNo || this.customerNo === this.displayChosenResearchGroup.leaderNo) {
        let parameter = this.displayChosenResearchGroup.researchGroupNo + ',' + new Date().getFullYear() + '-' + (new Date().getMonth() < 10 ? '0' + new Date().getMonth() : new Date().getMonth())
        this.gcapi('loadResearchGroupBillInfo', parameter).then(res => {
          if (res && res.body.result && this.isJson(res.body.result) && JSON.parse(res.body.result).json) {
            const obj = JSON.parse(JSON.parse(res.body.result).json)
            console.log('账单对象：', obj)
            this.billInfo = obj
            EMKT.setStoreItem('billInfo', obj)
          } else {
            console.log('获取账单失败')
          }
        })
      }
    },
    toggleShowChooseBox () {
      this.showChooseResearchGroup = !this.showChooseResearchGroup
    },
    splitMoney (moneyNumber) {
      if (moneyNumber === undefined) {
        return ''
      }
      return String(moneyNumber).replace(/\B(?=(?:\d{3})+\b)/g, ',')
    },
    checkBill () {
      this.$router.push({name: 'BillCheck'})
    },
    toOrder (index) {
      // 1:全部订单 2：待审批 3：执行中 4：已完成
      this.$router.push({name: 'ResearchGroupOrder', query: {tabIndex: index}})
    }
  },
  computed: {
    ...mapState([
      'sessionInfo'
    ]),
    ...mapGetters([
      'hasLogin', 'customerNo', 'displayChosenResearchGroup', 'customerName', 'researchGroupCharacter'
    ]),
    currentDiscount () {
      if (this.displayChosenResearchGroup && this.displayChosenResearchGroup.level) {
        return EMKT.benefitDiscount[this.displayChosenResearchGroup.level - 1]
      }
      return {}
    },
    approvalMemberListLength () {
      return this.approvalMemberList.length
    }
  },
  watch: {
    'displayChosenResearchGroup': {
      handler: 'getWaitApproveOrderNumAndBill',
      immediate: true
    }
  }
}
</script>
<style scoped>
.research_group_container {
  overflow-y:scroll;
  overflow-x:hidden;
  /*-webkit-overflow-scrolling:touch;*/
  height:100%;
  width: 100%;
}
.box_2 {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: column;
  background-color: #efeef3;
  width: 100vw;
  height: 100vh;
  top: 14.93vw;
}
.box_3 {
  display: flex;
  position: absolute;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #ffffff;
  width: 100vw;
  height: 100vh;
  /*top: 14.93vw;*/
}
.remind-info {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.remind-text {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  font-size: .7rem;
  color: #979797;
  line-height: 1.3rem;
  font-weight: 400;
}
.existOrder {
  margin-top: 8vw!important;
}
.unexistOrder {
  margin-top: 84.3vw!important;
}
.remind-title {
  font-size: .8rem;
  font-weight: 400;
  line-height: 2.1rem;
  color: #424242;
}
.hd {
  display: flex;
  position: fixed;
  top:0;
  left:0;
  align-items: center;
  flex-direction: row;
  /*background-color: #5878fa;*/
  width: 100vw;
  height: 14.93vw;
  z-index: 10;
  justify-content: center;
}


.navshare {
  position: absolute;
  left: 6.67vw;
  width: 10vw;
  height: 10vw;
  padding-top: 2vw;
  color:#ffffff;
}
.header_title {
  opacity: 1;
  /*margin-left: 29.33vw;*/
  max-width: 60.53vw;
  height: 5.87vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5.87vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 4.27vw;
  font-weight: 400;
}

.layerWrap {
  display: flex;
  position: absolute;
  /* top: 13.6vw; */
  left: 0;
  align-items: center;
  flex-direction: row;
  width: 100vw;
  height: 47.47vw;
  flex-shrink: 0;
}
.blue-layer {
  width:100vw;
  height:64.53vw;
}

.avator {
  position: absolute;
  top: 1.33vw;
  left: 13.33vw;
  width: 21.07vw;
  height: 21.07vw;
  border-radius: 10.53vw;
}

.container {
  display: flex;
  position: absolute;
  top: 1.33vw;
  left: 38.4vw;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  width: 33.07vw;
  /*height: 21.07vw;*/
}

.luWei {
  opacity: 1;
  max-width: 58.4vw;
  height: 5.33vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 3.73vw;
  font-weight: 400;
}

.outer {
  display: flex;
  flex-direction: row;
  margin-top: 1.33vw;
}

.outer2 {
  display: flex;
  flex-direction: row;
}

.tagWrap {
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: center;
  border-radius: 2.4vw;
  background-color: #fe654d;
  /* height: 4.8vw; */
  padding: 0 2vw;
  margin-right: 1.5vw;
}

.tag {
  opacity: 1;
  /* line-height: 4.53vw; */
  white-space: nowrap;
  color: #ffffff;
  font-size: 3.2vw;
  font-weight: 400;
}
.tagWrap_none {
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: center;
  border-radius: 2.4vw;
  /* height: 4.8vw; */
  padding: 0 2vw;
  margin-right: 1.5vw;
  box-sizing: border-box;
  margin-top: 1.33vw;
  background-color: #60d837;
}

.tagWrap_threshold {
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: center;
  border-radius: 2.4vw;
  /* height: 4.8vw; */
  padding: 0 2vw;
  margin-right: 1.5vw;
  box-sizing: border-box;
  margin-top: 1.33vw;
  background-color: #FF9400;
}

/* 权益css */
.benefit_detail {
  box-sizing: border-box;
  display: flex;
  position: absolute;
  top: 26.93vw;
  left: 7.47vw;
  align-items: flex-end;
  flex-direction: row;
  justify-content: space-between;
  padding-right: 5.33vw;
  padding-left: 5.33vw;
  width: 84.8vw;
  height: 26.93vw;
  flex-shrink: 0;
  /*background-color: #000;*/
}

.actionBg {
  position: absolute;
  top: 0;
  left: 0;
  width: 84.8vw;
  height: 26.93vw;
}

.text_G {
  position: absolute;
  top: 3.2vw;
  left: 5.33vw;
  opacity: 1;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #e6c3a0;
  font-size: 3.73vw;
  font-weight: bold;
}

.wrap_g {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  margin-bottom: 13.6vw;
  height: 5.33vw;
}

.info_g {
  opacity: 1;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 3.2vw;
  font-weight: 400;
}

.text_g {
  opacity: 1;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #e6c3a0;
  font-size: 3.2vw;
  font-weight: 400;
  margin-right: 1vw;
}

.num_g {
  opacity: 1;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #e6c3a0;
  font-size: 3.2vw;
  font-weight: bold;
}

.block_g {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  margin-bottom: 13.6vw;
  height: 5.33vw;
}

.info_benefit {
  opacity: 1;
  margin-right: 0.8vw;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #e6c3a0;
  font-size: 3.2vw;
  font-weight: 400;
}

.double_arrow {
  width: 2.4vw;
  height: 2.4vw;
}

.vip {
  position: absolute;
  top: 2.93vw;
  right: 5.07vw;
  opacity: 1;
  line-height: 5.33vw;
  white-space: pre;
  color: #e6c3a0;
  font-family: Times-Roman, Times;
  font-size: 3.73vw;
}



/* 首页课题组信息 */
.group_detail {
  display: flex;
  position: absolute;
  top: 42vw;
  left: 6.67vw;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  border-radius: 2.67vw;
  background-color: #ffffff;
  width: 86.67vw;
  height: 34.4vw;
  flex-shrink: 0;
}

.block {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-right: 5.6vw;
  padding-left: 6.67vw;
  width: 86.67vw;
}

.group {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  height: 9.6vw;
}

.info_2 {
  opacity: 1;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #424242;
  font-size: 3.73vw;
  font-weight: 700;
}

.num {
  opacity: 1;
  line-height: 4.53vw;
  white-space: nowrap;
  color: #424242;
  font-size: 3.2vw;
  font-weight: 400;
}

.iconzhuanrang {
  width: 4vw;
  height: 4vw;
}

.switchingResearchGroup {
  opacity: 1;
  margin-left: 1.07vw;
  width: 16vw;
  height: 4.53vw;
  text-align: right;
  line-height: 4.53vw;
  white-space: nowrap;
  color: #929292;
  font-size: 3.2vw;
  font-weight: 400;
}

.info_3 {
  opacity: 1;
  margin-left: 6.67vw;
  max-width: 76.8vw;
  height: 4.53vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 4.53vw;
  white-space: nowrap;
  color: #424242;
  font-size: 3.2vw;
  font-weight: 400;
}

.group_2 {
  display: flex;
  flex-direction: row;
  margin-top: 5.33vw;
  padding-left: 6.67vw;
  padding-right: 5.6vw;
  justify-content: space-between;
  width: 100%;
}

.character {
  opacity: 1;
  /* width: 9.6vw; */
  height: 4.53vw;
  line-height: 4.53vw;
  white-space: nowrap;
  color: #424242;
  font-size: 3.2vw;
  font-weight: 400;
}

.character-name {
  opacity: 1;
  /* width: 6.4vw; */
  height: 4.53vw;
  line-height: 4.53vw;
  white-space: nowrap;
  color: #ff9400;
  font-size: 3.2vw;
  font-weight: 400;
}

.bill_detail {
  display: flex;
  position: relative;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  /*margin-top: 8vw;*/
  border-radius: 2.67vw;
  background-color: #ffffff;
  width: 86.67vw;
  padding: 5vw 0;
  flex-shrink: 0;
}

.container_3 {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-right: 5.6vw;
  padding-left: 6.67vw;
  width: 86.67vw;
}

.block_2 {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  border-width: 1px;
  border-style: solid;
  border-radius: 1.33vw;
  border-color: rgba(146, 146, 146, 1);
  background-color: #ffffff;
  width: 27.2vw;
  height: 7.47vw;
}

.group_4 {
  display: flex;
  flex-direction: row;
  margin-top: 2.4vw;
  padding-left: 6.67vw;
  padding-right: 5.6vw;
  justify-content: flex-start;
  width: 100%;
}

.management {
  display: flex;
  position: relative;
  align-items: flex-start;
  flex-direction: column;
  border-radius: 2.67vw;
  background-color: #ffffff;
  width: 86.67vw;
  padding-bottom: 8vw;
  flex-shrink: 0;
  /* height: 63.2vw; */
}

.managementTools {
  opacity: 1;
  margin-top: 4.8vw;
  margin-left: 6.67vw;
  max-width: 80vw;
  height: 5.33vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #424242;
  font-size: 3.73vw;
  font-weight: 400;
}

.container_5 {
  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: space-evenly;
  margin-top: 6.67vw;
  width: 86.4vw;
  /* height: 9.33vw; */
}

.outer_3 {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: column;
  /* margin-left: 9.33vw; */
  width: 16vw;
  height: 15vw;
}

.setUpReconcilingPerson {
  opacity: 1;
  margin-top: 1.07vw;
  line-height: 4.53vw;
  white-space: nowrap;
  color: #424242;
  font-size: 3.2vw;
  font-weight: 400;
}


.orderNum {
  position: absolute;
  top: -.3rem;
  left: 9.5vw;
  color: white;
  background: #fe654d;
  border-radius: 0.5rem;
  line-height: 0.4rem;
  font-size: 0.5rem;
  margin-left: 0.1rem;
  padding: 0.2rem;
  height: .7rem
}




.priceWrap {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  /*height: 6.67vw;*/
}

.info_4 {
  opacity: 1;
  /*max-width: 17.6vw;*/
  /*overflow: hidden;*/
  /*text-overflow: ellipsis;*/
  /*line-height: 2.27vw;*/
  white-space: nowrap;
  color: #979797;
  font-size: 3.2vw;
  font-weight: 400;
}

.price {
  opacity: 1;
  line-height: 7vw;
  white-space: nowrap;
  color: #5878fa;
  font-size: 6vw;
  font-weight: 400;
  margin-left: .5vw;
  margin-top:1vw;
  font-family: PingFangSC-Medium;
}

.block_3 {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 2.8vw;
  padding-right: 5.6vw;
  padding-left: 6.67vw;
}

.moneyWrap {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  height: 10vw;
  margin-right: 12vw;
}

.info_5 {
  opacity: 1;
  /*margin-left: 3.2vw;*/
  /*max-width: 12.93vw;*/
  /*overflow: hidden;*/
  /*text-overflow: ellipsis;*/
  line-height: 4vw;
  white-space: nowrap;
  color: #979797;
  font-size: 3.2vw;
  font-weight: 400;
}

.money {
  opacity: 1;
  /*margin-left: 3.2vw;*/
  /*max-width: 12.93vw;*/
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5vw;
  white-space: nowrap;
  color: #5878fa;
  font-size: 4vw;
  font-weight: 400;
  margin-left: .5vw;
  font-family: PingFangSC-Medium;
  margin-top:1vw;
  /*font-size: 24px;*/
}

.anonymousIconfont {
  /*margin-right: 1vw;*/
  width: 4vw;
  height: 3vw;
  flex-shrink: 0;
}

.desc {
  opacity: 1;
  margin-left: 0.4vw;
  line-height: 3vw;
  white-space: nowrap;
  color: #fe654d;
  font-size: 3.2vw;
  font-weight: 400;
}
.desc_2 {
  opacity: 1;
  margin-left: 0.4vw;
  line-height: 4vw;
  color: #60d837;
  font-size: 3.2vw;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 16px;

}
.content-block {
  position: relative;
  margin-top: 83.93vw;
}
.main {
  display: flex;
  align-items: flex-start;
  flex-shrink: 0;
  flex-direction: column;
  border-width: 1px;
  border-style: solid;
  border-radius: 2.67vw;
  border-color: rgba(239, 238, 243, 1);
  background-color: #ffffff;
  width: 86.67vw;
  height: 41.6vw;
  margin-bottom: 6.67vw;

}
.container_4 {
  display: flex;
  position: relative;
  align-items: center;
  align-self: center;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 1.87vw;
  width: 74.13vw;
  height: 7.47vw;
}

.info_8 {
  opacity: 1;
  margin-top: 1.6vw;
  max-width: 46.93vw;
  height: 5.33vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #424242;
  font-size: 3.73vw;
  font-weight: bold;
}

.block_7 {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  border-width: 1px;
  border-style: solid;
  border-radius: 1.33vw;
  border-color: rgba(146, 146, 146, 1);
  background-color: #ffffff;
  width: 24vw;
  height: 7.47vw;
}

.icon_8 {
  margin-right: 1.6vw;
  margin-left: 2.93vw;
  width: 3.73vw;
  height: 4vw;
}

.text_4 {
  opacity: 1;
  max-width: 22.13vw;
  height: 4.53vw;
  overflow: hidden;
  text-align: right;
  text-overflow: ellipsis;
  line-height: 5.23vw;
  white-space: nowrap;
  color: #929292;
  font-size: 3.2vw;
  font-weight: 400;
  margin-left: 1.07vw;
}

.block_8 {
  display: flex;
  position: relative;
  align-items: flex-start;
  align-self: center;
  flex-direction: row;
  margin-top: 4.8vw;
  width: 67.47vw;
  height: 16.27vw;
}

.group_7 {
  display: flex;
  position: relative;
  align-items: flex-start;
  flex-direction: column;
  margin-top: 1.87vw;
  margin-right: 19.5vw;
  height: 14.4vw;
}

.icon_9 {
  position: relative;
  margin-left: 0.27vw;
  width: 9.33vw;
  height: 8.27vw;
}

.txt_7 {
  position: relative;
  opacity: 1;
  margin-top: 0.8vw;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #424242;
  font-size: 3.2vw;
  font-weight: 400;
}

.colorDiv_4 {
  position: absolute;
  top: 1.07vw;
  left: 8.03vw;
  border-radius: 3.73vw;
  background-color: #FE654D;
  width: 3.73vw;
  height: 3.73vw;
  text-align: center;
  font-size: 2.4vw;
  font-weight: 400;
  white-space: nowrap;
  color: #ffffff;
  line-height: 4vw;
}

.num_4 {
  position: absolute;
  opacity: 1;
  right: 1vw;
  top: -1vw;
  max-width: 16vw;
  height: 5.33vw;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  line-height: 6.00vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 2.4vw;
  font-weight: 400;
  /*transform:scale(0.75);*/
}

.container_51 {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: column;
  margin-top: 1.33vw;
  margin-right: 19.47vw;
  width: 9.6vw;
  height: 14.93vw;
}

.icon_10 {
  position: relative;
  width: 8.53vw;
  height: 9.33vw;
}

.word_5 {
  position: relative;
  opacity: 1;
  margin-top: 0.27vw;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #424242;
  font-size: 3.2vw;
  font-weight: 400;
}

.outer_4 {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: column;
  margin-top: 1.6vw;
  width: 9.6vw;
  height: 14.67vw;
}

.icon_11 {
  position: relative;
  width: 8.8vw;
  height: 8.53vw;
}

.text_5 {
  position: relative;
  opacity: 1;
  margin-top: 0.8vw;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #424242;
  font-size: 3.2vw;
  font-weight: 400;
}

.group_8 {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  margin-top: 1.87vw;
  margin-left: 6.13vw;
  height: 5.33vw;
}

.icon_12 {
  margin-right: 1.07vw;
  width: 2.93vw;
  height: 2.93vw;
}

.desc {
  opacity: 1;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #fe654d;
  font-size: 3.2vw;
  font-weight: 400;
}

.empty {
  position: relative;
  top: 2.07vw;
  align-self: center;
  border-top-width: 0.7px;
  border-top-style: solid;
  border-top-color: rgba(239, 238, 243, 1);
  width: 94.67vw;
  height: 0.27vw;
}
.colorDiv_Member {
  position: absolute;
  top: 0.8vw;
  left: 10.03vw;
  border-radius: 3.73vw;
  background-color: #FE654D;
  width: 3.73vw;
  height: 3.73vw;
  text-align: center;
  font-size: 2.4vw;
  font-weight: 400;
  white-space: nowrap;
  color: #ffffff;
  line-height: 4vw;
}
</style>



// WEBPACK FOOTER //
// ResearchGroupHome.vue?de7cfa22